import React, { useState } from 'react';
import { Download, CheckCircle, AlertCircle, ChevronDown, ChevronUp, Calendar, Mail, Edit2, Send, User } from 'lucide-react';
export function WonkaApplicationView() {
  const [expandedRef, setExpandedRef] = useState<string | null>(null);
  const [expandedGuarantor, setExpandedGuarantor] = useState<string | null>(null);
  const tradeReferences = [{
    id: 'sweetco',
    company: 'SweetCo Distributors',
    status: 'pending',
    statusText: 'Pending since January 15, 2026',
    emailsSent: '1 email sent',
    contact: {
      name: 'Robert Sweet',
      phone: '(555) 555-0142',
      email: 'r.sweet@sweetcodist.com'
    },
    details: null
  }, {
    id: 'candymax',
    company: 'CandyMax Wholesale',
    status: 'completed',
    statusText: 'Completed on January 12, 2026',
    emailsSent: '1 email sent',
    contact: {
      name: 'Patricia Candy',
      phone: '(717) 555-0188',
      email: 'p.candy@candymax.com'
    },
    details: {
      yearsAsCustomer: 8,
      creditLimit: '$125,000',
      currentBalance: '$12,500',
      paymentHabits: 'Prompt / Within Terms',
      recommended: 'Yes',
      responseDate: 'January 12, 2026'
    }
  }, {
    id: 'sugarworks',
    company: 'SugarWorks Supply Co.',
    status: 'not-sent',
    statusText: 'Not Sent',
    emailsSent: null,
    contact: {
      name: 'James Sugar',
      phone: '(703) 555-0177',
      email: 'j.sugar@sugarworks.com',
      address: '6885 Elm Street, McLean VA 22101'
    },
    details: null
  }];
  return <div className="space-y-6" data-id="element-3051">
      {/* Application Header */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-3052">
        <div className="flex items-center justify-between mb-4" data-id="element-3053">
          <div data-id="element-3054">
            <div className="flex items-center gap-3 mb-2" data-id="element-3055">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-3056">
                Credit Application
              </h2>
              <span className="px-3 py-1 bg-green-100 text-green-700 border border-green-300 rounded-full text-sm font-medium flex items-center gap-1" data-id="element-3057">
                <span className="text-lg" data-id="element-3058">🔍</span>
                Ready for Review
              </span>
            </div>
            <div className="text-sm text-gray-600 space-y-1" data-id="element-3059">
              <p data-id="element-3060">
                <span className="font-semibold" data-id="element-3061">Started On:</span> January 10,
                2026
              </p>
              <p data-id="element-3062">
                <span className="font-semibold" data-id="element-3063">Submitted On:</span> January 10,
                2026
              </p>
            </div>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-3064">
            <Download className="w-4 h-4" data-id="element-3065" />
            DOWNLOAD PDF
          </button>
        </div>
      </div>

      {/* Applicant Details */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-3066">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-3067">
          Applicant Details
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-3068">
          <div data-id="element-3069">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3070">
              Name
            </label>
            <p className="text-gray-900" data-id="element-3071">Charlie Bucket</p>
          </div>
          <div data-id="element-3072">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3073">
              Company
            </label>
            <p className="text-gray-900" data-id="element-3074">Wonka Industries</p>
          </div>
          <div data-id="element-3075">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3076">
              Role
            </label>
            <p className="text-gray-900" data-id="element-3077">Factory Manager</p>
          </div>
          <div data-id="element-3078">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3079">
              Department
            </label>
            <p className="text-gray-900" data-id="element-3080">Operations</p>
          </div>
          <div data-id="element-3081">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3082">
              Email
            </label>
            <div className="flex items-center gap-2" data-id="element-3083">
              <p className="text-gray-900" data-id="element-3084">charlie.bucket@wonka.com</p>
              <CheckCircle className="w-4 h-4 text-green-600" data-id="element-3085" />
            </div>
          </div>
          <div data-id="element-3086">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3087">
              Phone Number
            </label>
            {/* Modified: Changed label from 'Phone Number' to 'Phone'  */}
            <p className="text-gray-900" data-id="element-3088">(555) 555-0200</p>
          </div>
        </div>

        {/* Email Verification */}
        <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg" data-id="element-3089">
          <div className="flex items-start gap-3" data-id="element-3090">
            <CheckCircle className="w-5 h-5 text-green-600 mt-0.5" data-id="element-3091" />
            <div data-id="element-3092">
              <div className="font-semibold text-gray-900 mb-1" data-id="element-3093">
                Email Verification
              </div>
              <p className="text-sm text-gray-700" data-id="element-3094">
                Email verified and matches company domain.
              </p>
            </div>
          </div>
        </div>

        {/* IP Address */}
        <div className="mt-4" data-id="element-3095">
          <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3096">
            Location (IP Address)
          </label>
          <div className="flex items-center gap-2" data-id="element-3097">
            <p className="text-gray-900" data-id="element-3098">London, UK (185.45.23.112)</p>
            <CheckCircle className="w-4 h-4 text-green-600" data-id="element-3099" />
          </div>
        </div>

        {/* IP Verification */}
        <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg" data-id="element-3100">
          <div className="flex items-start gap-3" data-id="element-3101">
            <CheckCircle className="w-5 h-5 text-green-600 mt-0.5" data-id="element-3102" />
            <div data-id="element-3103">
              <div className="font-semibold text-gray-900 mb-1" data-id="element-3104">
                IP Address Verification
              </div>
              <p className="text-sm text-gray-700" data-id="element-3105">
                Applicant location matches company headquarters.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Company Information */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-3106">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-3107">
          Company Information
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-3108">
          <div data-id="element-3109">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3110">
              Legal Business Name
            </label>
            <p className="text-gray-900" data-id="element-3111">Wonka Industries Inc.</p>
          </div>
          <div data-id="element-3112">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3113">
              DBA
            </label>
            <p className="text-gray-900" data-id="element-3114">Wonka Chocolate Factory</p>
          </div>
          <div data-id="element-3115">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3116">
              Business Address
            </label>
            <p className="text-gray-900" data-id="element-3117">
              1 Chocolate Avenue
              <br data-id="element-3118" />
              Hershey, PA 17033
            </p>
          </div>
          <div data-id="element-3119">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3120">
              Years in Business
            </label>
            <p className="text-gray-900" data-id="element-3121">52 years</p>
          </div>
          <div data-id="element-3122">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3123">
              Tax ID / EIN
            </label>
            <p className="text-gray-900" data-id="element-3124">**-***7845</p>
          </div>
          <div data-id="element-3125">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3126">
              Industry
            </label>
            <p className="text-gray-900" data-id="element-3127">Confectionery & Candy Manufacturing</p>
          </div>
        </div>
      </div>

      {/* Requested Credit Terms */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-3128">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-3129">
          Requested Credit Terms
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-3130">
          <div data-id="element-3131">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3132">
              Requested Credit Limit
            </label>
            <p className="text-gray-900 text-lg font-semibold" data-id="element-3133">$100,000</p>
          </div>
          <div data-id="element-3134">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3135">
              Payment Terms
            </label>
            <p className="text-gray-900" data-id="element-3136">Net 30</p>
          </div>
          <div data-id="element-3137">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3138">
              Estimated Monthly Volume
            </label>
            <p className="text-gray-900" data-id="element-3139">$25,000 - $35,000</p>
          </div>
          <div data-id="element-3140">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3141">
              Purpose
            </label>
            <p className="text-gray-900" data-id="element-3142">Raw materials and ingredients</p>
          </div>
        </div>
      </div>

      {/* Trade References */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-3143">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-3144">
          Trade References
        </h3>
        <div className="space-y-3" data-id="element-3145">
          {tradeReferences.map(ref => <div key={ref.id} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-3146">
              {/* Collapsed Header */}
              <button onClick={() => setExpandedRef(expandedRef === ref.id ? null : ref.id)} className="w-full p-4 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-3147">
                <div className="flex items-center gap-4" data-id="element-3148">
                  <span className="font-semibold text-gray-900" data-id="element-3149">
                    {ref.company}
                  </span>
                  <div className="flex items-center gap-3 text-sm text-gray-600" data-id="element-3150">
                    <div className="flex items-center gap-1" data-id="element-3151">
                      <Calendar className="w-4 h-4" data-id="element-3152" />
                      {ref.statusText}
                    </div>
                    {ref.emailsSent && <>
                        <span className="text-gray-300" data-id="element-3153">•</span>
                        <div className="flex items-center gap-1" data-id="element-3154">
                          <Mail className="w-4 h-4" data-id="element-3155" />
                          {ref.emailsSent}
                        </div>
                      </>}
                  </div>
                </div>
                {expandedRef === ref.id ? <ChevronUp className="w-5 h-5 text-gray-400" data-id="element-3156" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-3157" />}
              </button>

              {/* Expanded Content */}
              {expandedRef === ref.id && <div className="border-t border-gray-200 p-6 bg-gray-50" data-id="element-3158">
                  {/* Reference Information */}
                  <div className="mb-6" data-id="element-3159">
                    <div className="flex items-center gap-2 mb-4" data-id="element-3160">
                      <span className="font-semibold text-gray-900" data-id="element-3161">
                        Reference Information
                      </span>
                      <Edit2 className="w-4 h-4 text-indigo-600 cursor-pointer" data-id="element-3162" />
                    </div>
                    <div className="grid grid-cols-2 gap-6" data-id="element-3163">
                      <div data-id="element-3164">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-3165">
                          Company Name
                        </label>
                        <p className="text-gray-900" data-id="element-3166">{ref.company}</p>
                      </div>
                      <div data-id="element-3167">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-3168">
                          Contact Name
                        </label>
                        <p className="text-gray-900" data-id="element-3169">{ref.contact.name}</p>
                      </div>
                      <div data-id="element-3170">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-3171">
                          Contact Phone Number
                        </label>
                        <p className="text-gray-900" data-id="element-3172">{ref.contact.phone}</p>
                      </div>
                      <div data-id="element-3173">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-3174">
                          Contact Work Email
                        </label>
                        <p className="text-gray-900" data-id="element-3175">{ref.contact.email}</p>
                      </div>
                      {ref.contact.address && <div className="col-span-2" data-id="element-3176">
                          <label className="text-sm text-gray-500 mb-1 block" data-id="element-3177">
                            Company Address
                          </label>
                          <p className="text-gray-900" data-id="element-3178">{ref.contact.address}</p>
                        </div>}
                    </div>
                  </div>

                  {/* Status-specific content */}
                  {ref.status === 'pending' && <div data-id="element-3179">
                      <div className="font-semibold text-gray-900 mb-2" data-id="element-3180">
                        Awaiting Response
                      </div>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-3181">
                        The reference request has been sent 1 times.
                      </p>
                      <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-3182">
                        <Send className="w-4 h-4" data-id="element-3183" />
                        SEND REMINDER
                      </button>
                    </div>}

                  {ref.status === 'completed' && ref.details && <div data-id="element-3184">
                      <div className="flex items-center gap-2 mb-4" data-id="element-3185">
                        <div className="font-semibold text-gray-900" data-id="element-3186">
                          Reference Completed
                        </div>
                        <CheckCircle className="w-5 h-5 text-green-600" data-id="element-3187" />
                      </div>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-3188">
                        Response received on {ref.details.responseDate}
                      </p>
                      <div className="grid grid-cols-2 gap-x-12 gap-y-4 text-sm" data-id="element-3189">
                        <div className="flex justify-between" data-id="element-3190">
                          <span className="text-gray-600" data-id="element-3191">
                            Years as Customer
                          </span>
                          <span className="font-medium text-gray-900" data-id="element-3192">
                            {ref.details.yearsAsCustomer}
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-3193">
                          <span className="text-gray-600" data-id="element-3194">Credit Limit</span>
                          <span className="font-medium text-gray-900" data-id="element-3195">
                            {ref.details.creditLimit}
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-3196">
                          <span className="text-gray-600" data-id="element-3197">Current Balance</span>
                          <span className="font-medium text-gray-900" data-id="element-3198">
                            {ref.details.currentBalance}
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-3199">
                          <span className="text-gray-600" data-id="element-3200">Payment Habits</span>
                          <span className="font-medium text-gray-900" data-id="element-3201">
                            {ref.details.paymentHabits}
                          </span>
                        </div>
                        <div className="flex justify-between col-span-2" data-id="element-3202">
                          <span className="text-gray-600" data-id="element-3203">Recommended</span>
                          <span className="font-medium text-gray-900" data-id="element-3204">
                            {ref.details.recommended}
                          </span>
                        </div>
                      </div>
                    </div>}

                  {ref.status === 'not-sent' && <div data-id="element-3205">
                      <div className="font-semibold text-gray-900 mb-2" data-id="element-3206">
                        Ready to Send
                      </div>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-3207">
                        This trade reference request has not yet been sent to
                        the contact.
                      </p>
                      <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-3208">
                        <Send className="w-4 h-4" data-id="element-3209" />
                        SEND REFERENCE
                      </button>
                    </div>}
                </div>}
            </div>)}
        </div>

        {/* Additional Trade References */}
        <div className="mt-6 p-4 bg-gray-50 rounded-lg" data-id="element-3210">
          <div className="font-semibold text-gray-900 mb-1" data-id="element-3211">
            Additional Trade References
          </div>
          <p className="text-sm text-gray-600 mb-4" data-id="element-3212">
            No additional references requested
          </p>
          <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-3213">
            <Send className="w-4 h-4" data-id="element-3214" />
            REQUEST ADDITIONAL TRADE REFERENCES
          </button>
        </div>
      </div>

      {/* Personal Guarantors */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-3215">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-3216">
          Personal Guarantors
        </h3>
        <div className="space-y-3" data-id="element-3217">
          {/* Willy Wonka - Completed */}
          <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-3218">
            {/* Collapsed Header */}
            <button onClick={() => setExpandedGuarantor(expandedGuarantor === 'willy' ? null : 'willy')} className="w-full p-4 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-3219">
              <div className="flex items-center gap-4" data-id="element-3220">
                <span className="font-semibold text-gray-900" data-id="element-3221">Willy Wonka</span>
                <div className="flex items-center gap-3 text-sm text-gray-600" data-id="element-3222">
                  <div className="flex items-center gap-1" data-id="element-3223">
                    <Calendar className="w-4 h-4" data-id="element-3224" />
                    {/* Changed from 'Completed on January 10, 2026' to just 'Completed on January 10, 2026' as in initial code's pattern */}
                    Completed on January 10, 2026
                  </div>
                  <span className="text-gray-300" data-id="element-3225">•</span>
                  <div className="flex items-center gap-1" data-id="element-3226">
                    <Mail className="w-4 h-4" data-id="element-3227" />1 email sent
                  </div>
                </div>
              </div>
              {expandedGuarantor === 'willy' ? <ChevronUp className="w-5 h-5 text-gray-400" data-id="element-3228" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-3229" />}
            </button>

            {/* Expanded Content */}
            {expandedGuarantor === 'willy' && <div className="border-t border-gray-200 p-6 bg-gray-50" data-id="element-3230">
                {/* Guarantor Information */}
                <div className="mb-6" data-id="element-3231">
                  <div className="flex items-center gap-2 mb-4" data-id="element-3232">
                    <User className="w-4 h-4 text-gray-600" data-id="element-3233" />
                    <span className="font-semibold text-gray-900" data-id="element-3234">
                      Guarantor Information
                    </span>
                    <Edit2 className="w-4 h-4 text-indigo-600 cursor-pointer" data-id="element-3235" />
                  </div>
                  <div className="grid grid-cols-2 gap-6" data-id="element-3236">
                    <div data-id="element-3237">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-3238">
                        Full Name
                      </label>
                      <p className="text-gray-900" data-id="element-3239">Willy Wonka</p>
                    </div>
                    <div data-id="element-3240">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-3241">
                        Title
                      </label>
                      <p className="text-gray-900" data-id="element-3242">Owner & Chief Chocolatier</p>
                    </div>
                    <div data-id="element-3243">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-3244">
                        Email
                      </label>
                      <p className="text-gray-900" data-id="element-3245">willy.wonka@wonka.com</p>
                    </div>
                    <div data-id="element-3246">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-3247">
                        Phone
                      </label>
                      {/* Modified: Changed label from 'Phone' to 'Phone' (already same), but keeping consistency */}
                      <p className="text-gray-900" data-id="element-3248">(555) 555-0100</p>
                    </div>
                    <div data-id="element-3249">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-3250">
                        Address
                      </label>
                      {/* Modified: Changed 'Address' label to 'Address' (already same), with new content below */}
                      <p className="text-gray-900" data-id="element-3251">
                        1 Chocolate Lane, London, UK W1A 1AA
                      </p>
                    </div>
                    <div data-id="element-3252">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-3253">
                        SSN
                      </label>
                      {/* Modified: Changed label from 'SSN' to 'SSN' (already same), with same content */}
                      <p className="text-gray-900" data-id="element-3254">***-**-1971</p>
                    </div>
                  </div>
                </div>

                {/* Guarantee Completed */}
                <div data-id="element-3255">
                  <div className="flex items-center gap-2 mb-4" data-id="element-3256">
                    <div className="font-semibold text-gray-900" data-id="element-3257">
                      Guarantee Completed
                    </div>
                    <CheckCircle className="w-5 h-5 text-green-600" data-id="element-3258" />
                  </div>
                  <p className="text-sm text-gray-600 mb-4" data-id="element-3259">
                    Personal guarantee signed on January 10, 2026
                  </p>
                  <div className="grid grid-cols-2 gap-x-12 gap-y-4 text-sm" data-id="element-3260">
                    <div className="flex justify-between" data-id="element-3261">
                      <span className="text-gray-600" data-id="element-3262">Guarantee Amount</span>
                      <span className="font-medium text-gray-900" data-id="element-3263">
                        $100,000
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-3264">
                      <span className="text-gray-600" data-id="element-3265">Date Signed</span>
                      <span className="font-medium text-gray-900" data-id="element-3266">
                        January 10, 2026
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-3267">
                      <span className="text-gray-600" data-id="element-3268">Guarantee Type</span>
                      <span className="font-medium text-gray-900" data-id="element-3269">
                        Unlimited
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-3270">
                      <span className="text-gray-600" data-id="element-3271">Expiration</span>
                      <span className="font-medium text-gray-900" data-id="element-3272">None</span>
                    </div>
                  </div>
                </div>
              </div>}
          </div>
        </div>

        {/* Additional Personal Guarantors */}
        <div className="mt-6 p-4 bg-gray-50 rounded-lg" data-id="element-3273">
          <div className="font-semibold text-gray-900 mb-1" data-id="element-3274">
            Additional Personal Guarantors
          </div>
          <p className="text-sm text-gray-600 mb-4" data-id="element-3275">
            No additional guarantors requested
          </p>
          <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-3276">
            <Send className="w-4 h-4" data-id="element-3277" />
            REQUEST ADDITIONAL PERSONAL GUARANTORS
          </button>
        </div>
      </div>

      {/* Banking Information */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-3278">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-3279">
          Banking Information
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-3280">
          <div data-id="element-3281">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3282">
              Bank Name
            </label>
            <p className="text-gray-900" data-id="element-3283">PNC Bank</p>
          </div>
          <div data-id="element-3284">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3285">
              Contact
            </label>
            <p className="text-gray-900" data-id="element-3286">Margaret Thompson</p>
          </div>
          <div data-id="element-3287">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3288">
              Type of Account
            </label>
            <p className="text-gray-900" data-id="element-3289">Business Checking</p>
          </div>
          <div data-id="element-3290">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3291">
              Account #
            </label>
            <p className="text-gray-900" data-id="element-3292">987654321</p>
          </div>
          <div data-id="element-3293">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3294">
              Email
            </label>
            <p className="text-gray-900" data-id="element-3295">m.thompson@pnc.com</p>
          </div>
          <div data-id="element-3296">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3297">
              City
            </label>
            <p className="text-gray-900" data-id="element-3298">Hershey</p>
          </div>
          <div data-id="element-3299">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3300">
              State
            </label>
            <p className="text-gray-900" data-id="element-3301">PA</p>
          </div>
          <div data-id="element-3302">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3303">
              Phone #
            </label>
            <p className="text-gray-900" data-id="element-3304">717-555-0300</p>
          </div>
          <div data-id="element-3305">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3306">
              Fax #
            </label>
            <p className="text-gray-900" data-id="element-3307">717-555-0301</p>
          </div>
        </div>
      </div>

      {/* Signature */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-3308">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-3309">Signature</h3>

        {/* Terms & Conditions */}
        <div className="mb-6" data-id="element-3310">
          <h4 className="text-lg font-bold text-gray-900 mb-4" data-id="element-3311">
            Terms & Conditions
          </h4>
          <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg mb-4" data-id="element-3312">
            <p className="text-sm text-gray-700 leading-relaxed" data-id="element-3313">
              I understand that should my account become delinquent (terms of
              sale are based upon date of invoice) and that if the creditor
              elects to employ a third party to collect monies due, my company
              will be responsible for not only the original amount billed, but
              also all costs associated with the collection efforts including
              but not limited to reasonable attorney fees. Cash in Advance
              restrictions may be placed on any past due account. Customer will
              notify the creditor, in writing, of any ownership changes or legal
              means of doing business by the company under which credit was
              established.
            </p>
          </div>
          <p className="text-sm font-semibold text-gray-900 mb-6" data-id="element-3314">
            By signing the below you give Wonka Industries Ltd., permission to
            check your bank and trade references.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-3315">
          <div data-id="element-3316">
            <label className="text-sm font-medium text-gray-500 mb-2 block" data-id="element-3317">
              Signature
            </label>
            <div className="border-2 border-gray-300 rounded-lg p-4 bg-white h-32 flex items-center justify-center" data-id="element-3318">
              <svg viewBox="0 0 200 60" className="w-full h-full" style={{
              maxWidth: '200px'
            }} data-id="element-3319">
                <path d="M 15 35 Q 25 15, 45 30 Q 65 45, 85 25 Q 105 10, 125 35 Q 145 50, 165 30 Q 175 20, 185 35" stroke="#1f2937" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-3320" />
              </svg>
            </div>
          </div>
          <div data-id="element-3321">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3322">
              Printed Name
            </label>
            <p className="text-gray-900" data-id="element-3323">Willy Wonka</p>
          </div>
          <div data-id="element-3324">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3325">
              Title
            </label>
            <p className="text-gray-900" data-id="element-3326">Owner & Chief Chocolatier</p>
          </div>
          <div data-id="element-3327">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-3328">
              Date
            </label>
            <p className="text-gray-900" data-id="element-3329">2026-01-10</p>
          </div>
        </div>
      </div>
    </div>;
}